<template>
  <div v-if="last_month" class="money-html">
    <div class="moneyBox">
      <div class="boxLeft1">
        <div class="header1" style="margin-bottom: 20px">
          <h2 class="text-lg font-medium truncate">我的余额</h2>
        </div>
        <div class="div1">
          <div class="number">
            <el-popover
                    placement="top-start"
                    width="50"
                    trigger="hover"
                    :content="String(userInfo.fin_invalid + userInfo.fin_valid) ">
              <div slot="reference" class="itemContent">
                ￥{{ userInfo.fin_invalid + userInfo.fin_valid }}
              </div>
            </el-popover>
            <div class="itemContent1">我的余额</div>
            <div class="itemContent2">
              上月结算 <span>￥{{ last_month.settled }}</span>
            </div>
          </div>
          <div class="number">
            <el-popover
                    placement="top-start"
                    width="50"
                    trigger="hover"
                    :content="String(userInfo.fin_valid) ">
              <div  slot="reference" class="itemContent" style="color: #1890ff">
                ￥{{ userInfo.fin_valid }}
              </div>
            </el-popover>
<!--            <div class="itemContent" style="color: #1890ff">-->
<!--              ￥{{ userInfo.fin_valid }}-->
<!--            </div>-->
            <div class="itemContent1">可提现金额</div>
            <div class="itemContent2">
              本月结算
              <span style="color: #6fd04f">￥{{ current_month.settled }}</span>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="buttom1" @click="isRecharge = true">
            <span>充值</span>
          </div>
          <div class="buttom2" @click="isWithdraw = true">
            <span>提现</span>
          </div>
          <div class="buttom3">
            待结算<span>￥{{ current_month.settling }}</span>
          </div>
        </div>
      </div>
      <div class="boxLeft2">
        <div class="header2" style="margin-bottom: 20px">
          <h2 class="text-lg font-medium truncate">支出</h2>
        </div>
        <div class="div2">
          <div class="itemHeader">
            <img src="@/assets/images/money1.png" alt="" />
            <!-- 小标 -->
            <div
              v-if="expend.num != 'NaN'"
              :class="expend.type === 1 ? 'div3' : 'div4'"
            >
              {{ expend.num }}%
            </div>
          </div>
          <div class="zhichu">
            <div class="itemContent">￥{{ current_month.out }}</div>
            <div class="itemContent1">本月支出</div>
          </div>
        </div>
      </div>
      <div class="boxLeft2">
        <div class="header2" style="margin-bottom: 20px">
          <h2 class="text-lg font-medium truncate">收入</h2>
        </div>
        <div class="div2">
          <div class="itemHeader">
            <img src="@/assets/images/xiangshang.png" alt="" />
            <!-- 小标 -->
            <div
              v-if="income.num != 'NaN'"
              :class="income.type === 1 ? 'div3' : 'div4'"
            >
              {{ income.num }}%
            </div>
          </div>
          <div class="zhichu">
            <div class="itemContent" style="color: #75d257">
              ￥{{ current_month.in }}
            </div>
            <div class="itemContent1">本月收入</div>
          </div>
        </div>
      </div>
      <div class="boxLeft2">
        <div class="header2" style="margin-bottom: 20px">
          <h2 data-v-ced23842="" class="text-lg font-medium truncate">
            邀请奖励
          </h2>
        </div>
        <div class="div2">
          <div class="itemHeader">
            <img src="@/assets/images/my.png" alt="" />
            <!-- 小标 -->
            <div
              v-if="award.num != 'NaN'"
              :class="income.type === 1 ? 'div3' : 'div4'"
            >
              {{ award.num }}%
            </div>
          </div>
          <div class="zhichu">
            <div class="itemContent" style="color: #1890ff">
              ￥{{ current_month.invite_commission }}
            </div>
            <div class="itemContent1">本月邀请奖励</div>
          </div>
        </div>
      </div>
      <div class="boxLeft3">
        <div class="header3">
          <h2 data-v-ced23842="" class="text-lg font-medium truncate">支出</h2>
        </div>
        <div class="div4">
          <!-- 搜索框 -->
          <div class="sousuo">
            <el-input
              v-model="searchA"
              class="input"
              placeholder="请输入单号"
              prefix-icon="el-icon-search"
            ></el-input>
            <!-- 搜索按钮 -->
            <el-button class="searchButton" type="primary" @click="getSearchA"
              >搜索</el-button
            >
          </div>

          <!-- 日历 -->
          <div class="rili intro-x">
            <el-date-picker
              v-model="date1"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getPickerVlaue1"
            >
            </el-date-picker>
          </div>
          <!-- 列表 -->
          <div class="list">
            <el-table
              v-loading="TabLoading1"
              :data="financeListAll[0]"
              style="width: 100%"
              stripe
              height="539"
              @sort-change="getSort1"
            >
              <el-table-column prop="oid" label="单号" width="150">
              </el-table-column>
              <el-table-column prop="memo" label="内容"> </el-table-column>
              <el-table-column
                prop="fin_amt"
                label="金额"
                sortable="custom"
                width="150"
              >
              </el-table-column>
              <el-table-column
                prop="ctime"
                label="时间"
                sortable="custom"
                width="150"
              >
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.ctime | formatDate }}
                  </div>
                </template>
              </el-table-column>
              <div slot="empty" class="emptyImg">
                <img src="../assets/images/kong-dingdan.png" alt="" />
              </div>
            </el-table>
          </div>
          <!-- 页面分页设置 -->
          <div class="block">
            <el-pagination
              :current-page.sync="currentPage1"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="sizes, prev, pager, next"
              :total="pageCountA"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="boxLeft3">
        <div class="header3">
          <h2 data-v-ced23842="" class="text-lg font-medium truncate">收入</h2>
        </div>
        <div class="div4">
          <!-- 搜索框 -->
          <div class="sousuo">
            <el-input
              v-model="searchB"
              class="input"
              placeholder="请输入单号"
              prefix-icon="el-icon-search"
            ></el-input>
            <!-- 搜索按钮 -->
            <el-button class="searchButton" type="primary" @click="getSearchB"
              >搜索</el-button
            >
          </div>

          <!-- 日历 -->
          <div class="rili intro-x">
            <el-date-picker
              v-model="date2"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getPickerVlaue2"
            >
            </el-date-picker>
          </div>
          <!-- 列表 -->
          <div class="list">
            <el-table
              v-loading="TabLoading2"
              :data="financeListAll[1]"
              style="width: 100%; height: 539px"
              stripe
              height="539"
              @sort-change="getSort2"
            >
              <el-table-column prop="oid" label="单号" width="150">
              </el-table-column>
              <el-table-column prop="memo" label="内容"> </el-table-column>
              <el-table-column prop="fin_amt" label="金额" sortable width="150">
              </el-table-column>
              <el-table-column prop="ctime" label="时间" sortable width="150">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.ctime | formatDate }}
                  </div>
                </template>
              </el-table-column>
              <div slot="empty" class="emptyImg">
                <img src="../assets/images/kong-dingdan.png" alt="" />
              </div>
            </el-table>
          </div>
          <!-- 页面分页设置 -->
          <div class="block">
            <el-pagination
              :current-page.sync="currentPage2"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="sizes, prev, pager, next"
              :total="pageCountB"
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in">
      <div v-if="isRecharge" class="shadeRecharge">
        <div class="maskLayer"></div>
        <div class="betaToast">
          <div class="toastHeader">充值</div>
          <div class="toastTitleText">
            <div class="text1">输入需要充值的金额</div>
            <div class="text2">
              填入所需要充值的金额后选择支付方式即可前往充值
            </div>
          </div>
          <!-- 输入金额 -->
          <div class="inputBox inputMoney">
            <span>¥</span>
            <input class="input" type="text" placeholder="请输入充值的金额" />
          </div>
          <!-- 微信支付 -->
          <div
            class="inputBox weixin-box"
            :class="{ payActivate: payType === 1 }"
            @click="payType = 1"
          >
            <span class="ImgBox weixinBox">
              <img src="../assets/images/mini-weixin.png" alt="" />
            </span>
            <span>微信支付</span>
            <i :class="payType === 1 ? 'el-icon-success' : 'yuan'"></i>
          </div>

          <!-- 支付宝支付 -->

          <div
            class="inputBox weixin-box"
            :class="{ payActivate: payType === 2 }"
            @click="payType = 2"
          >
            <span class="ImgBox zhifubaoBox">
              <img src="../assets/images/mini-zhifubao.png" alt="" />
            </span>
            <span>支付宝支付</span>
            <i :class="payType === 2 ? 'el-icon-success' : 'yuan'"></i>
          </div>

          <!-- 前往充值 -->
          <div class="inputButtom">
            <span class="span1" @click="isRecharge = false">取消</span>
            <span class="span2" @click="getPayMoney">前往充值</span>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in">
      <div v-if="isWithdraw" class="shadeRecharge">
        <div class="maskLayer"></div>

        <div v-show="isWithdraw" class="betaToast" style="max-height: 516px">
          <div class="toastHeader">提现</div>
          <div class="toastTitleText">
            <div class="text1">输入需要提现的金额</div>
            <div class="text2">
              填入所需要提现的金额后即可提现至绑定的支付宝账号
            </div>
          </div>
          <!-- 输入金额 -->
          <div class="inputBox inputMoney">
            <span>¥</span>
            <input class="input" type="text" placeholder="请输入提现的金额" />
          </div>
          <!-- 账户金额 -->
          <div class="inputBox weixin-box" style="padding: 10px 20px">
            <div class="ListFloat" style="margin-bottom: 6px">
              <div
                style="
                  float: left;
                  width: 180px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                <span
                  style="
                    color: #999999;
                    display: inline-block;
                    margin-right: 15px;
                  "
                  >可提现</span
                >
                <span class="display:inline-bloock;"
                  >¥{{ userInfo.fin_valid }}</span
                >
              </div>
              <div
                style="
                  float: right;
                  width: 110px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                <span
                  style="
                    color: #999999;
                    display: inline-block;
                    margin-right: 15px;
                  "
                  >上月结算</span
                >
                <span style="color: #6fd04f">¥{{ last_month.settled }}</span>
              </div>
            </div>
            <div class="ListFloat">
              <div
                style="
                  float: left;
                  width: 110px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                <span
                  style="
                    color: #999999;
                    display: inline-block;
                    margin-right: 15px;
                  "
                  >待结算</span
                >
                <span class="display:inline-bloock;"
                  >¥ {{ current_month.settling }}</span
                >
              </div>

              <div
                style="
                  float: right;
                  width: 110px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                <span
                  style="
                    color: #999999;
                    display: inline-block;
                    margin-right: 15px;
                  "
                  >本月结算</span
                >
                <span style="color: #6fd04f"
                  >¥ {{ current_month.settled }}</span
                >
              </div>
            </div>
          </div>

          <!-- 支付宝账号 -->

          <div class="inputBox weixin-box">
            <span class="ImgBox zhifubaoBox">
              <img src="../assets/images/mini-zhifubao.png" alt="" />
            </span>
            <span>支付宝账号</span>
            <div v-if="userInfo.acc_alipay" class="floatRight">{{userInfo.acc_alipay}}</div>
            <div v-else class="floatRight">暂未绑定</div>
          </div>

          <!-- 前往充值 -->
          <div class="inputButtom">
            <span class="span1" @click="isWithdraw = false">取消</span>

            <span v-if="userInfo.acc_alipay" class="span2" @click="goMoney">提现</span>
            <span v-else class="span2" @click="goBinding" >前往绑定</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import request  from '../utils/request'


import Cookies from "js-cookie";

import { formatDate } from "../utils/time";

export default {
  filters: {
    formatDate: function (value) {
      return formatDate(value);
    },
  },
  data() {
    return {
      TabLoading1: true,
      TabLoading2: true,
      daterange: "",
      currentPage1: 1,
      currentPage2: 1,
      financeListAll: [],
      current_month: null,
      last_month: null,
      expend: null,
      income: null,
      award: null,
      isRecharge: false,
      isWithdraw: false,
      payType: 0,
      searchB: null,
      searchA: null,
      pageCountA: null,
      pageCountB: null,
      amt_sortA: "",
      amt_sortB: "",
      time_sortB: "",
      time_sortA: "",
      date1: null,
      date2: null,
      limit1: 10,
      limit2: 10,
      start_time1: "",
      end_time1: "",
      start_time2: "",
      end_time2: "",
    };
  },

  computed: {
    userInfo: function () {
      return JSON.parse(Cookies.get("userInfo"));
    },
  },

  mounted() {
    this.getInit();
    // console.log(this.userInfo.acc_alipay)
  },

  methods: {
    // 提现
    goMoney(){
      // this.isWithdraw = false
      this.$message.warning('请联系客服！')
    },
    // 前往绑定支付宝
    goBinding(){
      this.isWithdraw = false
      this.$router.push('/Dashboard/profile')
    },
    // 时间选择
    getPickerVlaue1: function (value) {
      if (this.date1 === null) {
        this.start_time1 = "";
        this.end_time1 = "";
      } else {
        this.start_time1 = formatDate(new Date(this.date1[0]).getTime() / 1000);
        this.end_time1 = formatDate(new Date(this.date1[1]).getTime() / 1000);
      }

      this.TabLoading1 = true;
      this.getFinanceList({
        type: 0,
        content: this.searchA,
        amt_sort: this.amt_sortA,
        time_sort: this.time_sortA,
        limit: this.limit1,
        page: this.currentPage1,
        start_time: this.start_time1,
        end_time: this.end_time1,
      }).then((res) => {
        this.financeListAll[0] = res.data;
        this.pageCountA = res.count;
        this.TabLoading1 = false;
        this.$forceUpdate();
      });
    },


    getPickerVlaue2: function (value) {
      if (this.date2 === null) {
        this.start_time2 = "";
        this.end_time2 = "";
      } else {
        this.start_time2 = formatDate(new Date(this.date2[0]).getTime() / 1000);
        this.end_time2 = formatDate(new Date(this.date2[1]).getTime() / 1000);
      }

      this.TabLoading2 = true;
      this.getFinanceList({
        type: 1,
        content: this.searchB,
        amt_sort: this.amt_sortB,
        time_sort: this.time_sortB,
        limit: this.limit2,
        page: this.currentPage2,
        start_time: this.start_time2,
        end_time: this.end_time2,
      }).then((res) => {
        this.financeListAll[1] = res.data;
        this.pageCountB = res.count;
        this.TabLoading2 = false;
        this.$forceUpdate();
      });
    },






    // 列表1排序
    getSort1: function (column) {
      this.TabLoading1 = true;
      if (column.prop === "fin_amt") {
        if (column.order === "ascending") {
          // 正序
          this.amt_sortA = "desc";
        } else {
          this.amt_sortA = "asc";
        }
        this.time_sortA = "";
        this.getFinanceList({
          type: 0,
          content: this.searchA,
          amt_sort: this.amt_sortA,
          time_sort: this.time_sortA,
          limit: this.limit1,
          page: this.currentPage1,
          start_time: this.start_time1,
          end_time: this.end_time1,
        }).then((res) => {
          this.financeListAll[0] = res.data;
          this.pageCountA = res.count;
          this.TabLoading1 = false;
          this.$forceUpdate();
        });
      } else {
        if (column.order === "ascending") {
          // 正序
          this.time_sortA = "DESC";
        } else {
          this.time_sortA = "asc";
        }
        this.amt_sortA = "";

        this.getFinanceList({
          type: 0,
          content: this.searchA,
          amt_sort: this.amt_sortA,
          time_sort: this.time_sortA,
          limit: this.limit1,
          page: this.currentPage1,
          start_time: this.start_time1,
          end_time: this.end_time1,
        }).then((res) => {
          this.financeListAll[0] = res.data;
          this.pageCountA = res.count;
          this.TabLoading1 = false;
          this.$forceUpdate();
        });
      }
    },

    // 列表2排序
    getSort2: function (column) {
      this.TabLoading2 = true;
      if (column.prop === "fin_amt") {
        if (column.order === "ascending") {
          // 正序
          this.amt_sortB = "desc";
        } else {
          this.amt_sortB = "asc";
        }
        this.time_sortB = "";
        this.getFinanceList({
          type: 1,
          content: this.searchB,
          amt_sort: this.amt_sortB,
          time_sort: this.time_sortB,
          limit: this.limit2,
          page: this.currentPage2,
          start_time: this.start_time2,
          end_time: this.end_time2,
        }).then((res) => {
          this.financeListAll[1] = res.data;
          this.pageCountB = res.count;
          this.TabLoading2 = false;
          this.$forceUpdate();
        });
      } else {
        if (column.order === "ascending") {
          // 正序
          this.time_sortA = "DESC";
        } else {
          this.time_sortA = "asc";
        }
        this.amt_sortA = "";
        this.getFinanceList({
          type: 1,
          content: this.searchB,
          amt_sort: this.amt_sortB,
          time_sort: this.time_sortB,
          limit: this.limit2,
          page: this.currentPage2,
          start_time: this.start_time2,
          end_time: this.end_time2,
        }).then((res) => {
          this.financeListAll[1] = res.data;
          this.pageCountB = res.count;
          this.TabLoading2 = false;
          this.$forceUpdate();
        });
      }
    },

    // 前往充值
    getPayMoney: function () {
      this.$alert("请联系客服!", "提示", {
        confirmButtonText: "知道了",
        callback: (action) => {
          // console.log("用户点击了确定");
          this.isRecharge = false;
        },
      });
    },
    handleSizeChange1(val) {
      this.limit1 = val;
      this.TabLoading1 = true;
      this.currentPage1 = 1;
      this.getFinanceList({
        type: 0,
        content: this.searchA,
        amt_sort: this.amt_sortA,
        time_sort: this.time_sortA,
        limit: this.limit1,
        page: this.currentPage1,
        start_time: this.start_time1,
        end_time: this.end_time1,
      }).then((res) => {
        this.financeListAll[0] = res.data;
        this.pageCountA = res.count;
        this.TabLoading1 = false;
        this.$forceUpdate();
      });
    },
    handleSizeChange2(val) {
      this.limit2 = val;
      this.TabLoading2 = true;
      this.currentPage2 = 1;
      this.getFinanceList({
        type: 0,
        content: this.searchB,
        amt_sort: this.amt_sortB,
        time_sort: this.time_sortB,
        limit: this.limit2,
        page: this.currentPage2,
        start_time: this.start_time1,
        end_time: this.end_time1,
      }).then((res) => {
        this.financeListAll[1] = res.data;
        this.pageCountB = res.count;
        this.TabLoading2 = false;
        this.$forceUpdate();
      });
    },

    handleCurrentChange1(val) {
      this.TabLoading1 = true;
      this.currentPage1 = val;
      this.getFinanceList({
        type: 0,
        content: this.searchA,
        amt_sort: this.amt_sortA,
        time_sort: this.time_sortA,
        limit: this.limit1,
        page: this.currentPage1,
        start_time: this.start_time1,
        end_time: this.end_time1,
      }).then((res) => {
        this.financeListAll[0] = res.data;
        this.pageCountA = res.count;
        this.TabLoading1 = false;
        this.$forceUpdate();
      });
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.TabLoading2 = true;
      this.getFinanceList({
        type: 1,
        content: this.searchB,
        amt_sort: this.amt_sortB,
        time_sort: this.time_sortB,
        limit: this.limit2,
        page: this.currentPage2,
        start_time: this.start_time2,
        end_time: this.end_time2,
      }).then((res) => {
        this.financeListAll[1] = res.data;
        this.pageCountB = res.count;
        this.TabLoading2 = false;
        this.$forceUpdate();
      });
    },

    getInit: function () {
      this.TabLoading1 = true;
      this.TabLoading2 = true;
      Promise.all([
        this.getFinanceList({
          type: 0,
          limit: this.limit1,
          amt_sort: this.amt_sortA,
          time_sort: this.time_sortA,
          page: 1,
          start_time: this.start_time1,
          end_time: this.end_time1,
        }),
        this.getFinanceList({
          type: 1,
          limit: this.limit2,
          amt_sort: this.amt_sortB,
          time_sort: this.time_sortB,
          page: 1,
        }),
      ]).then((res) => {
        this.pageCountA = res[0].count;
        this.pageCountB = res[1].count;
        this.financeListAll = [res[0].data, res[1].data];

        this.TabLoading1 = false;
        this.TabLoading2 = false;
      });
      this.getFinanceStatistic();
    },

    getFinanceList: function (param) {
      return new Promise((resolve, reject) => {
        request({
          url:"/api/finance/list",
          method:'POST',
          data:param
        }).then((res) => {
          resolve(res);
        });
      });
    },

    getFinanceStatistic: function () {
      request({
        url:"/api/finance/statistic"
      }).then((res) => {
        this.last_month = res.data.last_month;
        this.current_month = res.data.current_month;
        // 收入
        let a = this.last_month.in;
        let b = this.current_month.in;

        // console.log(a, b);
        if (b > a) {
          this.income = {
            type: 1,
            num: ([(b - a) / a] * 100).toFixed(1),
          };
        } else {
          this.income = {
            type: 2,
            num: ([(b - a) / a] * 100).toFixed(1),
          };
        }
        // 支出
        let c = this.last_month.out; // 上月
        let d = this.current_month.out; // 本月
        if (b > a) {
          this.income = {
            type: 1,
            num: ([(b - a) / a] * 100).toFixed(1),
          };
        } else {
          this.income = {
            type: 2,
            num: ([(b - a) / a] * 100).toFixed(1),
          };
        }

        if (d > c) {
          this.expend = {
            type: 1,
            num: ([(d - c) / c] * 100).toFixed(1),
          };
        } else {
          this.expend = {
            type: 2,
            num: ([(c - d) / c] * 100).toFixed(1),
          };
        }

        let e = this.last_month.invite_commission; // 上月
        let f = this.current_month.invite_commission; // 本月

        // console.log(e, f);

        if (f > e) {
          this.award = {
            type: 1,
            num: ([(f - e) / e] * 100).toFixed(1),
          };
        } else {
          this.award = {
            type: 2,
            num: ([(e - f) / e] * 100).toFixed(1),
          };
        }

        // 假设原来的数是f,现在的数是d,
        // 如果f>e,上升的百分数=[(f-e)/e]*100%;
        // 如果e>f,下降的百分数=[e-f)/e]*100%.
      });
    },

    // 搜索A
    getSearchA: function () {
      this.TabLoading1 = true;
      this.getFinanceList({
        type: 0,
        content: this.searchA,
        amt_sort: this.amt_sortA,
        time_sort: this.time_sortA,
        limit: this.limit1,
        page: 1,
        start_time: this.start_time1,
        end_time: this.end_time1,
      }).then((res) => {
        this.currentPage1 = 1;
        this.financeListAll[0] = res.data;
        this.pageCountA = res.count;
        this.TabLoading1 = false;
        this.$forceUpdate();
      });
    },

    // 搜索B
    getSearchB: function () {
      this.getFinanceList({
        type: 1,
        content: this.searchB,
        amt_sort: this.amt_sortB,
        time_sort: this.time_sortB,
        limit: this.limit,
        page: this.pageCountB,
        start_time: this.start_time2,
        end_time: this.end_time2,
      }).then((res) => {
        this.financeListAll[1] = res.data;
        this.pageCountB = res.count;
        this.currentPage2 = 1;
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="scss" >
.money-html {
  width: 100%;
  overflow: hidden;
  .moneyBox {
    overflow: hidden;
    height: 100%;
    width: 100%;
    .boxLeft1 {
      white-space: nowrap;
      overflow: hidden;
      width: 35%;
      margin: 4% 1% 0 0;
      float: left;
      .div1 {
        width: 100%;
        height: 151px;
        background: #ffffff;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
        opacity: 1;
        border-radius: 22px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 5%;
        overflow: hidden;
        .number {
          width: 40%;
          float: left;

          .itemContent {
       
            height: 40px;
            font-size: 1.6vw;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 40px;
            color: #333333;
            opacity: 1;
            cursor:pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .itemContent1 {
            margin-bottom: 15px;
            width: 64px;
            height: 21px;
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 21px;
            color: #718096;
            opacity: 1;
          }
          .itemContent2 {
            margin-bottom: 5px;
            width: 56px;
            height: 19px;
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #718096;
            opacity: 1;
            span {
              width: 41px;
              height: 19px;
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 19px;
              color: #1890ff;
              opacity: 1;
            }
          }
        }
        .buttom1 {
          width: 15%;
          float: left;
          padding-bottom: 1.6%;
          span {
            color: #fff;
            background: #1890ff;
            font-size: 13px;
            width: 67px;
            display: inline-block;
            text-align: center;
            height: 31px;
            line-height: 30px;
            border-radius: 7px;
            cursor: pointer;
          }
        }
        .buttom2 {
          width: 15%;
          float: left;
          padding-bottom: 1.6%;
          span {
            color: #1890ff;
            background: #d8ecff;
            font-size: 14px;
            width: 67px;
            display: inline-block;
            text-align: center;
            height: 31px;
            line-height: 30px;
            border-radius: 7px;
            cursor: pointer;
          }
        }
        .buttom3 {
          float: left;
          padding-bottom: 1.6%;
          width: 42px;
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          color: #718096;
          opacity: 1;
          span {
            width: 41px;
            height: 19px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #6fd04f;
            opacity: 1;
          }
        }
      }
    }
    .boxLeft2 {
      white-space: nowrap;
      overflow: hidden;
      width: 20%;
      margin: 4% 1% 0 0;
      float: left;
      .div2 {
        width: 100%;
        height: 151px;
        padding: 1.6%;
        background: #ffffff;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
        opacity: 1;
        border-radius: 22px;
        margin-bottom: 20px;
        box-sizing: border-box;
        overflow: hidden;
        .itemHeader {
          float: left;
          width: 100%;
          padding: 3% 5% 0;
          height: 44.7px;
          img {
            float: left;
          }
          .div4 {
            margin: 1.6%;
            float: right;
            padding: 4px 8px;
            background: #ffe2e4;
            opacity: 1;
            border-radius: 12px;
            color: #ff4242;
            font-size: 12px;
            text-align: center;
          }
          .div4::after {
            content: "↓";
          }
          .div3 {
            margin: 1.6%;
            float: right;
            padding: 4px 8px;
            background: #e7f7f3;
            opacity: 1;
            border-radius: 12px;
            color: #6ed04e;
            font-size: 12px;
            text-align: center;
          }
          .div3::after {
            content: "↑";
          }
        }
        .zhichu {
          padding: 2% 2% 2% 7%;
          float: left;
          .itemContent {
            width: 120px;
            height: 40px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 40px;
            color: #ff4141;
            opacity: 1;
            padding-bottom: 50px;
          }
          .itemContent1 {
            width: 64px;
            height: 21px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 21px;
            color: #718096;
            opacity: 1;
          }
        }
      }
    }
    .boxLeft3 {
      white-space: nowrap;
      box-sizing: border-box;
      overflow: hidden;
      width: 50%;
      float: left;
      padding: 1.6% 1.6% 1.6% 0;
      .div4 {
        overflow: hidden;
        width: 100%;
        height: 708px;
        background: #ffffff;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
        opacity: 1;
        border-radius: 22px;
        margin: 2% 0% 1%;
        .sousuo {
          width: 45%;

          float: left;
          padding: 1.2%;
          .input {
            width: 77%;
            .el-input__prefix {
              left: 15px;
            }
          }

          .buttom {
            border-radius: 8px;
          }
        }
        .rili {
          float: right;
          width: 50%;
          margin-right: 0%;
          overflow: hidden;
          padding: 2%;
        }
        .list {
          margin: 1% 2% 1%;
        }
        .block {
          padding: 1.6% 0 1.6%;
          .el-pager li.active {
            background: #1890ff;
            color: #fff !important;
          }
          .el-pagination__sizes {
            margin: 2px 5px;
            float: right;
            font-weight: 400;
            color: #606266;
          }
          .el-pagination .el-select .el-input .el-input__inner {
            padding-right: 30px;
            border-radius: 7px;
            background: #1890ff;
            height: 35px;

            box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
          }
          .el-pagination__sizes .el-input .el-input__inner {
            font-size: 14px;
            padding-left: 8px;
            color: #fff;
            font-family: Microsoft YaHei;
          }
        }
      }
    }
  }
}

.w-60 {
  width: 230px;
}

.emptyImg {
  display: inline-block;
  margin-top: 50px;
}

// 遮罩层
.shadeRecharge {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.maskLayer {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #000000;
  opacity: 0.7;
  width: 100%;
  height: 100%;
}

.betaToast {
  /*弹窗*/
  width: 24vw;
  min-width: 400px;
  max-height: 483px;

  box-sizing: border-box;
  background: #ffffff;
  border-radius: 22px;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  overflow: hidden;
  .toastHeader {
    height: 65px;
    line-height: 65px;
    width: 100%;
    text-indent: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #f4f4f4;
    font-size: 16px;
    color: #333333;
  }
  .toastTitleText {
    height: 75px;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding-top: 19px;
    div {
      width: 100%;
    }
    .text1 {
      color: #333333;
      font-size: 16px;
    }
    .text2 {
      color: #718096;
      font-size: 12px;
    }
  }

  .inputBox {
    width: 91.3%;
    margin: 0 auto 16px;
    min-height: 76px;
    line-height: 2.8;
    background: #f4f7f8;
    border-radius: 16px;
    box-sizing: border-box;
    border: 1px solid #f4f7f8;
  }

  .inputMoney {
    text-indent: 20px;
    color: #333333;
    font-size: 26px;
    .input {
      background: none;
      outline: 0px;
      border: none;
      display: inline-block;
      height: 100%;
      max-width: calc(100% - 36px);
    }
    .input:focus {
      border: none;
      box-shadow: none;
    }
  }
}

.weixin-box {
  cursor: pointer;
  .ImgBox {
    width: 66px;
    text-align: center;
    line-height: 66px;
    height: 66px;
    border-radius: 50%;
    display: inline-block;
    margin: 5px 10px 5px 5px;
    color: #333333;
    font-size: 14px;
    img {
      display: inline-block;
      width: 32px;
    }
  }
  .weixinBox {
    background: #ddffd2;
  }

  .zhifubaoBox {
    background: #e4f2ff;
  }

  .el-icon-success {
    float: right;
    font-size: 20px;
    line-height: 76px;
    margin-right: 20px;
    color: #1890ff;
  }
  .yuan {
    float: right;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #e6e8ee;
    box-sizing: border-box;
    margin: 30px 20px 0 0;
  }
}

.inputButtom {
  height: 67px;
  line-height: 67px;
  text-align: right;
  box-sizing: border-box;
  border-top: 1px solid #f4f4f4;
  font-size: 14px;
  padding: 0 20px;
  .span1 {
    width: 80px;
    height: 39px;
    border: 1px solid #e2e8f0;
    text-align: center;
    line-height: 39px;
    box-sizing: border-box;
    border-radius: 6px;
    display: inline-block;
    margin-right: 4px;
    color: #333333;
    cursor: pointer;
    background: #fff;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    width: 110px;
    height: 39px;
    background: #1890ff;
    border-radius: 6px;
    line-height: 39px;
    text-align: center;
    display: inline-block;
    color: #fff;
    cursor: pointer;
  }
  .span2:active {
    background: #389bf8;
  }
}

.payActivate {
  border: 1px solid #1890ff !important;
}

.floatRight {
  float: right;
  height: 76px;
  line-height: 76px;
  color: #4fa5ff;
  font-size: 14px;
  padding-right: 20px;
}

.ListFloat {
  width: 100%;
  overflow: hidden;
}

// 响应
@media screen and (max-width: 600px) {
  .moneyBox .boxLeft1 {
    width: 100% !important;
    .div1 {
      height: auto !important;
      .number {
        width: 100% !important;
        .itemContent {
          font-size: 27px !important;
        }
      }
      .buttom1 {
        margin-top: 5% !important;
        width: 35% !important;
      }
      .buttom2 {
        margin-top: 5% !important;
        width: 35% !important;
      }
      .buttom3 {
        margin-top: 8% !important;
      }
    }
  }
  .moneyBox .boxLeft2 {
    width: 100% !important;
  }
  .moneyBox .boxLeft3 {
    display: none;
  }
}

.searchButton {
  height: 38px;
}

// 响应
@media screen and (min-width: 600px) and (max-width: 1030px) {
  .moneyBox .boxLeft1 {
    width: 100% !important;
    .div1 {
      height: 185px !important;
      .number {
        width: 40% !important;
        .itemContent {
          font-size: 37px !important;
        }
      }
      .buttom1 {
        width: 15% !important;
      }
      .buttom2 {
        width: 15% !important;
      }
      .buttom3 {
        margin-top: 5px;
      }
    }
  }
  .moneyBox .boxLeft2 {
    width: 100% !important;

    .div2 {
      height: 185px !important;
      padding: 0 !important;
    }
  }
  .moneyBox .boxLeft3 {
    padding: 0 !important;
    width: 100% !important;
  }
}
</style>